/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import type { FC } from "react";
import { Link } from "./Link";

interface Props {
  className?: string;
}

export const X: FC<Props> = ({ className }: Props) => {
  return (
    <Link
      href="https://x.com/staffmartialart"
      aria-label="Follow staffmartialart on X"
      target="_blank"
      rel="noreferrer"
    >
      <svg
        className={`${className}`}
        aria-hidden="true"
        fill="none"
        height="33"
        viewBox="0 0 35 33"
        width="35"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.1838 2.0625H6.49628C4.78827 2.0625 3.40253 3.44824 3.40253 5.15625V27.8438C3.40253 29.5518 4.78827 30.9375 6.49628 30.9375H29.1838C30.8918 30.9375 32.2775 29.5518 32.2775 27.8438V5.15625C32.2775 3.44824 30.8918 2.0625 29.1838 2.0625ZM26.032 12.2977C26.0449 12.4781 26.0449 12.665 26.0449 12.8455C26.0449 18.4336 21.791 24.8725 14.018 24.8725C11.6203 24.8725 9.39667 24.1764 7.52753 22.9775C7.86913 23.0162 8.19784 23.0291 8.54589 23.0291C10.5246 23.0291 12.3422 22.3588 13.7924 21.2244C11.9361 21.1857 10.3764 19.9676 9.84139 18.2918C10.4924 18.3885 11.0789 18.3885 11.7492 18.2145C9.81561 17.8213 8.36542 16.1197 8.36542 14.0637V14.0121C8.92616 14.3279 9.58358 14.5213 10.2732 14.5471C9.69343 14.1614 9.21812 13.6382 8.88972 13.0241C8.56133 12.4101 8.39006 11.7243 8.3912 11.0279C8.3912 10.2416 8.59745 9.51973 8.96483 8.89453C11.0467 11.4598 14.1726 13.1355 17.6789 13.316C17.0795 10.4479 19.2258 8.12109 21.8039 8.12109C23.0221 8.12109 24.1178 8.63027 24.8912 9.45527C25.8451 9.2748 26.7603 8.92031 27.5724 8.43691C27.2566 9.4166 26.5928 10.2416 25.7162 10.7637C26.567 10.6734 27.392 10.435 28.1525 10.1062C27.5789 10.9506 26.857 11.6982 26.032 12.2977Z"
          fill="white"
        />
      </svg>
    </Link>
  );
};
